<template>
  <div>
    <form @submit.prevent="pressOk">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <strong>Nombre</strong>
            <input type="text" v-model="sTarget.name" class="form-control no-limited" />
          </div>
          <div class="form-group">
            <b-form-checkbox v-model="sTarget.requiresDetailSpecification" name="requiresDetailSpecification" switch>
              Requiere Especificar Detalle
            </b-form-checkbox>
            <small class="text-muted">Si está activo, el campo "Detalles de objetivo" será obligatorio en la
              solicitud.</small>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <button class="btn btn-block btn-success">
              <i class="fa fa-save"></i>
              Guardar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { Post, Get } from "../../helper/axios.js";
import toastr from "toastr";
export default {
  data() {
    return {
      apiUrl: this.$store.getters.apiUrl,
      Post,
      Get
    };
  },
  props: ["sTarget"],
  created() {
  },

  methods: {
    pressOk() {
      if (this.sTarget) {
        var valid = true;
        var message = "Agregue o corrija los siguiente campos:<br>";
        if (!this.sTarget.name) {
          message = message + "* Nombre.<br>";
          valid = false;
        }
        if (valid) {
          this.$emit("pressOk");
        } else {
          toastr.info(message);
        }
      }
    },
  }
};
</script>


